<template>
  <div class="modal-content">
    <p class="text_left">{{$t('seller.sell.CancelAuctionModal.tip1')}}</p>
    <div style="padding: 0 50px">
      <div class="text_left base_padding flex_1">
        <md-field displayOnly>
          <label>{{$t("seller.sell.CancelAuctionModal.lable1")}}</label>
          <md-input :value="auctionId" disabled></md-input>
        </md-field>
        <md-field displayOnly>
          <label>{{$t("seller.sell.CancelAuctionModal.lable2")}}</label>
          <md-input :value="carePhoneNumber" disabled></md-input>
        </md-field>
      </div>
    </div>
    <p class="text_left">{{$t('seller.sell.CancelAuctionModal.tip2')}}</p>

  <div class="flex flex_between" style="width:100%">
    <div></div>
    <md-button class="md-blank" @click.stop="closeModal">{{ $t('common.close') }}</md-button>
  </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  props: {
    auctionId: { type: String, default: "" },
  },
  computed: {
    ...mapGetters(['carePhoneNumber'])
  },
  methods: {
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>